import * as t from "react";
const e = /*#__PURE__*/ t.createContext(null), o = ()=>t.useContext(e);
export { e as default, o as useDesktopContainerType };
